module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-10-active-bft-56bf94303e0b252e94f3e354eddc6b1c.png";